export const PATH_STEP_1 = "selecteer-je-klus";
export const PATH_STEP_2 = "samenstellen-van-je-klus";
export const PATH_STEP_3 = "contactgegevens";
export const PATH_STEP_4 = "bevestiging";
export const PATH_STEP_5 = "bedankt";
